<template>
  <div
    class="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 md:p-6 lg:p-8 font-sans"
  >
    <div class="max-w-7xl mx-auto">
      <!-- Header -->
      <!-- <div
        class="flex flex-col md:flex-row md:items-center md:justify-between mb-8"
      >
        <div>
          <h1 class="text-3xl font-bold text-gray-900 flex items-center gap-3">
            <span class="bg-indigo-600 text-white p-2 rounded-xl shadow-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
            Activity Logs
          </h1>
          <p class="text-gray-500 mt-1 ml-1">
            Track all events and changes in your system
          </p>
        </div>
        <div class="flex items-center gap-3 mt-4 md:mt-0">
          <button
            class="px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-xl hover:bg-gray-50 transition shadow-sm flex items-center gap-2 text-sm font-medium"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
              />
            </svg>
            Filter
          </button>
          <button
            class="px-4 py-2 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 transition shadow-md flex items-center gap-2 text-sm font-medium"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              />
            </svg>
            Export
          </button>
        </div>
      </div> -->

      <!-- Stats Cards -->
      <!-- <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <div
          v-for="stat in stats"
          :key="stat.label"
          class="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 hover:shadow-md transition"
        >
          <div class="flex items-center justify-between">
            <div>
              <p class="text-sm text-gray-500 font-medium">{{ stat.label }}</p>
              <p class="text-2xl font-bold text-gray-900 mt-1">
                {{ stat.value }}
              </p>
            </div>
            <div :class="stat.bgColor" class="p-3 rounded-xl">
              <component
                :is="stat.icon"
                class="h-5 w-5"
                :class="stat.iconColor"
              />
            </div>
          </div>
           <div class="mt-3 flex items-center text-xs">
            <span
              :class="stat.trendColor"
              class="font-medium flex items-center"
            >
              {{ stat.trend }}
              <svg
                v-if="stat.trendUp"
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 ml-0.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M5 10l7-7m0 0l7 7m-7-7v18"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                class="h-3 w-3 ml-0.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M19 14l-7 7m0 0l-7-7m7 7V3"
                />
              </svg>
            </span>
            <span class="text-gray-400 ml-2">vs last week</span>
          </div>
        </div>
      </div> -->

      <!-- Search and filters bar -->
      <div
        class="bg-white rounded-2xl shadow-sm border border-gray-100 p-4 mb-6"
      >
        <div class="flex flex-col lg:flex-row lg:items-center gap-4">
          <div class="flex-1 relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="Search logs by user, action, or details..."
              class="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 transition bg-gray-50/50"
            />
          </div>
          <div class="flex flex-wrap gap-2">
            <select
              v-model="selectedType"
              class="px-4 py-3 border border-gray-200 rounded-xl bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm"
            >
              <option value="">All types</option>
              <option value="user">User</option>
              <option value="system">System</option>
              <option value="security">Security</option>
              <option value="data">Data</option>
            </select>
            <select
              v-model="selectedDate"
              class="px-4 py-3 border border-gray-200 rounded-xl bg-white text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 text-sm"
            >
              <option value="">All time</option>
              <option value="today">Today</option>
              <option value="week">This week</option>
              <option value="month">This month</option>
            </select>
            <button
              class="px-4 py-2 text-indigo-600 hover:bg-indigo-50 rounded-xl transition text-sm font-medium flex items-center gap-1"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
              Clear
            </button>
          </div>
        </div>
      </div>

      <!-- Logs Table / Cards -->
      <div
        class="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden"
      >
        <div class="overflow-x-auto">
          <table class="w-full">
            <thead class="bg-gray-50/80 border-b border-gray-100">
              <tr>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  Event
                </th>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  User
                </th>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  Action
                </th>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  Details
                </th>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  IP Address
                </th>
                <th
                  class="px-6 py-4 text-left text-xs font-semibold text-gray-500 uppercase tracking-wider"
                >
                  Date & Time
                </th>
                <th
                  class="px-6 py-4 text-right text-xs font-semibold text-gray-500 uppercase tracking-wider"
                ></th>
              </tr>
            </thead>
            <tbody class="divide-y divide-gray-100">
              <tr
                v-for="log in filteredLogs"
                :key="log.id"
                class="hover:bg-gray-50/50 transition"
              >
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div>
                      <p class="text-sm font-medium text-gray-900">
                        {{ log.event }}
                      </p>
                      <p class="text-xs text-gray-400">{{ log.category }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <div class="flex items-center">
                    <div>
                      <p class="text-sm font-medium text-gray-900">
                        {{ log.user_string }}
                      </p>
                      <p class="text-xs text-gray-400">{{ log.browser }}</p>
                    </div>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span
                    :class="log.actionBadge"
                    class="px-2.5 py-1 text-xs font-medium rounded-full"
                  >
                    {{ log.action }}
                  </span>
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-600 max-w-[300px] truncate"
                >
                  <div>
                    <p class="text-sm font-medium text-gray-900">
                      {{ log.details }}
                    </p>
                    <p class="text-xs text-gray-400">
                      Model: {{ log.entity_type }}
                    </p>
                  </div>
                </td>
                <td
                  class="px-6 py-4 whitespace-nowrap text-sm text-gray-500 font-mono"
                >
                  {{ log.ip_address }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  <div class="flex items-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-3.5 w-3.5 mr-1 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                    <div>
                      <div class="text-sm font-medium text-gray-900">
                        {{ log.date }}
                      </div>
                      <div class="text-sm text-gray-500">
                        {{ log.time }}
                      </div>
                    </div>
                  </div>
                </td>
                <!-- <td
                  class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
                >
                  <button
                    class="text-indigo-600 hover:text-indigo-900 p-1 rounded-full hover:bg-indigo-50 transition"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z"
                      />
                    </svg>
                  </button>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty state -->
        <div v-if="filteredLogs.length === 0" class="text-center py-16 px-4">
          <div
            class="bg-gray-50 rounded-full w-20 h-20 flex items-center justify-center mx-auto mb-4"
          >
            <svg
              class="w-12 h-12 text-gray-300 mb-3"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-8 w-8 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <h3 class="text-lg font-medium text-gray-900 mb-1">No logs found</h3>
          <p class="text-gray-500">
            Try adjusting your search or filter to find what you're looking for.
          </p>
        </div>

        <!-- Pagination -->
        <div
          class="bg-gray-50/50 px-6 py-4 border-t border-gray-100 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4"
        >
          <p class="text-sm text-gray-500">
            Showing
            <span class="font-medium">{{ filteredLogs.length }}</span> of
            <span class="font-medium">{{ logs.length }}</span> logs
          </p>
          <div class="flex items-center gap-2">
            <button
              class="px-3 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-white transition disabled:opacity-50"
              :disabled="currentPage === 1"
            >
              Previous
            </button>
            <button
              class="px-3 py-1.5 bg-indigo-600 text-white rounded-lg text-sm hover:bg-indigo-700 transition"
            >
              1
            </button>
            <button
              class="px-3 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-white transition"
            >
              2
            </button>
            <button
              class="px-3 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-white transition"
            >
              3
            </button>
            <span class="text-gray-400">...</span>
            <button
              class="px-3 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-white transition"
            >
              8
            </button>
            <button
              class="px-3 py-1.5 border border-gray-200 rounded-lg text-sm text-gray-600 hover:bg-white transition"
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Floating Action Button -->
    <button
      @click="getActivityLogs"
      class="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-indigo-800 text-white shadow-lg transition-all duration-300 hover:bg-indigo-700 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      aria-label="Refresh page"
    >
      <!-- Refresh icon (SVG) -->
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-6 w-6"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        :class="{ 'animate-spin': isRefreshing }"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        />
      </svg>
    </button>
  </div>

  <div
    v-if="isRefreshing"
    class="fixed inset-0 ml-64 bg-white/80 backdrop-blur-sm flex items-center justify-center z-50"
  >
    <div class="relative">
      <!-- Outer ring -->
      <div class="w-16 h-16 border-4 border-gray-200 rounded-full"></div>
      <!-- Inner spinning gradient ring -->
      <div
        class="w-16 h-16 border-4 border-transparent rounded-full absolute top-0 left-0 border-t-indigo-500 border-r-indigo-700 animate-spin"
      ></div>
      <!-- Center dot -->
      <div
        class="w-3 h-3 bg-indigo-800 rounded-full absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import api from "@/utils/api";

import { useNotifications } from "@/composables/useNotifications";

// Notification system
const { showError, formatValidationErrors } = useNotifications();

// State
const isRefreshing = ref(false);

// Icons as components (using simple SVG strings for demo, in real app you'd use e.g. HeroIcons)
// const DocumentIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>',
// };
// const UserIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>',
// };
// const ShieldIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20.618 5.984A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" /></svg>',
// };
// const DatabaseIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4" /></svg>',
// };
// const TrendingUpIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" /></svg>',
// };
// const ClockIcon = {
//   template:
//     '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>',
// };

// Stats data
// const stats = ref([
//   {
//     label: "Total Events",
//     value: "0",
//     icon: DocumentIcon,
//     bgColor: "bg-indigo-100",
//     iconColor: "text-indigo-600",
//     trend: "+12.3%",
//     trendColor: "text-green-600",
//     trendUp: true,
//   },
//   {
//     label: "Active Users",
//     value: "0",
//     icon: UserIcon,
//     bgColor: "bg-emerald-100",
//     iconColor: "text-emerald-600",
//     trend: "+5.2%",
//     trendColor: "text-green-600",
//     trendUp: true,
//   },
//   {
//     label: "Security Alerts",
//     value: "0",
//     icon: ShieldIcon,
//     bgColor: "bg-amber-100",
//     iconColor: "text-amber-600",
//     trend: "-2.1%",
//     trendColor: "text-red-600",
//     trendUp: false,
//   },
//   {
//     label: "Data Changes",
//     value: "0",
//     icon: DatabaseIcon,
//     bgColor: "bg-purple-100",
//     iconColor: "text-purple-600",
//     trend: "+23.5%",
//     trendColor: "text-green-600",
//     trendUp: true,
//   },
// ]);

// Logs data
const logs = ref([
  // {
  //   id: 1,
  //   event: "User Login",
  //   category: "Authentication",
  //   user: "John Smith",
  //   userInitials: "JS",
  //   action: "Success",
  //   details: "Logged in from Chrome on Windows",
  //   ip: "192.168.1.45",
  //   time: "2 min ago",
  //   type: "user",
  //   icon: UserIcon,
  //   typeClass: "bg-blue-100",
  //   iconColor: "text-blue-600",
  //   actionBadge: "bg-green-100 text-green-700",
  // },
]);

// Filter states
const searchQuery = ref("");
const selectedType = ref("");
const selectedDate = ref("");
const currentPage = ref(1);

// Computed filtered logs
const filteredLogs = computed(() => {
  return logs.value.filter((log) => {
    // Search filter
    if (searchQuery.value) {
      const query = searchQuery.value.toLowerCase();
      const matchesSearch =
        log.event.toLowerCase().includes(query) ||
        log.user.toLowerCase().includes(query) ||
        log.details.toLowerCase().includes(query) ||
        log.ip.includes(query);
      if (!matchesSearch) return false;
    }

    // Type filter
    if (selectedType.value && log.type !== selectedType.value) {
      return false;
    }

    // Date filter (simplified demo - in real app you'd compare timestamps)
    if (selectedDate.value === "today") {
      // Just for demo: assume first 3 logs are today
      return log.id <= 3;
    }
    if (selectedDate.value === "week") {
      return log.id <= 6;
    }

    return true;
  });
});

const getActivityLogs = async () => {
  isRefreshing.value = true;
  try {
    const response = await api.get("/api/v1/activity/logs");
    logs.value = response.data.data;
  } catch (error) {
    console.log(error);
    const details = formatValidationErrors(error);
    showError("Error", "Failed to save user", details, 5000);
  } finally {
    isRefreshing.value = false;
  }
};

// Initialize
onMounted(() => {
  getActivityLogs();
});
</script>

<style scoped>
/* Smooth transitions and modern touches */
button,
input,
select {
  transition: all 0.2s ease;
}

/* Custom scrollbar for a sleek look */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
